import {
  CalendarCheck,
  Clock,
  PhoneOff,
  Send,
  Zap,
  type LucideIcon,
} from 'lucide-react'
import { Badge } from '@/components/ui/badge'

type TriggerMeta = { icon: LucideIcon; description: string }

// Known `trigger` values on app_nova_workflows and what fires each one. Unknown
// triggers fall back to a neutral icon and the raw value as its own label.
const TRIGGER_META: Record<string, TriggerMeta> = {
  booking: {
    icon: CalendarCheck,
    description: 'Runs when a booking action is requested during a call.',
  },
  'post-call': {
    icon: PhoneOff,
    description: 'Runs after a call completes.',
  },
  time: {
    icon: Clock,
    description: 'Runs on a schedule.',
  },
  dispatch: {
    icon: Send,
    description: 'Runs when dispatched on demand.',
  },
}

/** Human blurb for what fires a trigger — falls back to a neutral sentence. */
export function getTriggerDescription(trigger: string): string {
  return TRIGGER_META[trigger]?.description ?? 'Trigger for this workflow.'
}

// `showLabel` prints the word "Trigger" before the value — useful on the list
// card, but redundant under a "Trigger" section heading, where we drop it.
export function TriggerChip({
  trigger,
  showLabel = true,
}: {
  trigger: string
  showLabel?: boolean
}) {
  const Icon = TRIGGER_META[trigger]?.icon ?? Zap

  return (
    <Badge variant="secondary" className="gap-1.5">
      <Icon className="size-3.5 shrink-0 text-indigo-500 dark:text-indigo-400" />
      {showLabel && <span className="text-muted-foreground">Trigger</span>}
      <span className="font-medium">{trigger}</span>
    </Badge>
  )
}
